export const environment = {
  production: false,
  api: 'https://api-safetrack.safetrace.com.br',
  frontUrl: 'https://qima.agrotransparencia.com.br',
  gpaUrl: 'https://conectagis.safetrace.com.br',
  qualificacaoFornecedoresUrl: 'https://dd.safe-trace.com'
};
